var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8478 4.43947L17.5121 5.08233C17.3353 5.10376 17.2603 5.32072 17.3862 5.44661L18.9746 7.03501L12.921 13.0886L10.1942 10.3645C10.0255 10.1957 9.75496 10.1984 9.58888 10.3645L0.971918 18.9841C0.932039 19.0244 0.909668 19.0788 0.909668 19.1355C0.909668 19.1921 0.932039 19.2465 0.971918 19.2868L2.17728 20.4975C2.26031 20.5805 2.39692 20.5805 2.47995 20.4975L9.89156 13.0886L12.6157 15.8127C12.7844 15.9788 13.055 15.9788 13.221 15.8127L20.4907 8.5484L22.0791 10.1368C22.1075 10.1651 22.1434 10.1849 22.1825 10.1938C22.2217 10.2028 22.2625 10.2006 22.3005 10.1875C22.3384 10.1744 22.3719 10.1509 22.3972 10.1197C22.4225 10.0884 22.4384 10.0508 22.4434 10.0109L23.0862 4.67518C23.105 4.53858 22.9871 4.42072 22.8478 4.43947Z",
    fill: "#58B947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseIcon);
export default __webpack_public_path__ + "static/media/increase-icon.f5fd4e4b0b3044e3e2a260e1a8ab7783.svg";
export { ForwardRef as ReactComponent };